import styled from '@emotion/styled';
import { Casino, Search } from '@mui/icons-material';
import { Dispatch, SetStateAction, useState } from 'react';
import { Button } from '~/modules/Elements/Button';
import { Tooltip } from '~/modules/Elements/Tooltip';
import QuickSearch from '~/routes/SingASong/SongSelection/Components/QuickSearch';

import { AppliedFilters } from '~/routes/SingASong/SongSelection/Hooks/useSongListFilter';

interface Props {
  onRandom: () => void;
  setFilters: Dispatch<SetStateAction<AppliedFilters>>;
  filters: AppliedFilters;
  keyboardControl: boolean;
}

export default function AdditionalListControls({ onRandom, setFilters, filters, keyboardControl }: Props) {
  const [searchActive, setSearchActive] = useState(false);

  const clearSearch = () => {
    setFilters((current) => ({ ...current, search: '' }));
  };

  return (
    <>
      <Container>
        <Tooltip title="Search" place="left">
          <RoundButton
            onClick={() => (searchActive ? clearSearch() : setSearchActive(true))}
            data-test="search-song-button">
            <Search />
          </RoundButton>
        </Tooltip>
        <Tooltip title="Pick random" place="left">
          <RoundButton onClick={onRandom} data-test="random-song-button">
            <Casino />
          </RoundButton>
        </Tooltip>
      </Container>

      <QuickSearch
        setFilters={setFilters}
        filters={filters}
        visible={searchActive}
        setVisible={setSearchActive}
        keyboardControl={keyboardControl}
      />
    </>
  );
}

const RoundButton = styled(Button)`
  box-shadow: 0 0.8rem 2rem rgba(0, 0, 0, 0.2);
  background: var(--walky-surface-raised);
  color: var(--walky-orange);
  border: 2px solid var(--walky-orange);
  width: clamp(54px, 4.8vw, 68px);
  height: clamp(54px, 4.8vw, 68px);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover,
  &:focus-visible {
    background: var(--walky-orange);
    color: white;
  }

  svg {
    width: clamp(26px, 2.8vw, 34px);
    height: clamp(26px, 2.8vw, 34px);
  }
`;

const Container = styled.div`
  pointer-events: none;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  //bottom: 50%;
  bottom: max(1rem, env(safe-area-inset-bottom));
  right: 1.25rem;
  z-index: 100;
  gap: 0.85rem;
`;
